import { ColDef } from 'ag-grid-community';
import { differenceInDays, parseISO } from 'date-fns';
import { SalesCampaignModel } from 'src/infrastructure/rest-api/api-types';
import { formatStringDate } from 'src/utils/formatAsMonthYear';

export type SalesCampaignsRow = SalesCampaignModel & {
    duration: number;
};

export const defaultColumns: ColDef<SalesCampaignsRow>[] = [
    {
        field: 'name',
        headerName: 'Campaign name',
    },
    {
        field: 'storefrontType',
        headerName: 'Storefront type',
        valueGetter({ data }) {
            return data?.storefrontType?.name ?? '';
        },
    },
    {
        field: 'startDate',
        headerName: 'Start date',
        valueGetter({ data }) {
            if (!data?.startDate) {
                return '';
            }
            return formatStringDate(data.startDate);
        },
    },
    {
        field: 'endDate',
        headerName: 'End date',
        valueGetter({ data }) {
            if (!data?.endDate) {
                return '';
            }
            return formatStringDate(data.endDate);
        },
    },
    {
        field: 'duration',
        headerName: 'Duration',
        valueGetter({ data }) {
            if (!data?.startDate || !data?.endDate) {
                return '';
            }
            return differenceInDays(parseISO(data.endDate), parseISO(data.startDate));
        },
    },
];
